module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAMAAABYzB2OAAAAOVBMVEUAAAD//v6QkJHGxsbf39/x8fE6Ojw9PT1GRkZRUVFpaWlwcHCIiIiioqKxsbEEBAQeHh4NDg4pKSk48VfqAAAAD3RSTlMAA4tHJRD18ubZu7GVdGCDdXy6AAAAOklEQVQI12NgYGBkQAOMYEwk4BViZ0bRycLBDwRcrHARRiZBfgE+EIFQyMbPzQpUysnPQ5QlCPPJAQCnWAFKCSfymwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up-arrow.png
// module id = 131
// module chunks = 5